import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	updateProjectNameError: {
		id: 'horizontal-nav-common.services.rename-project.update-project-name-error',
		defaultMessage: "We couldn't update your project name. Try again.",
		description: 'Message to be shown in an error dialog if updating the project name fails.',
	},
	updateProjectNameErrorGalaxia: {
		id: 'horizontal-nav-common.services.rename-project.update-project-name-error-galaxia',
		defaultMessage: "We couldn't update your space name. Try again.",
		description: 'Message to be shown in an error dialog if updating the project name fails.',
	},
});
